import React from "react";
import ProgressBarComponent from "./progressBarComponent";
import AlertComponent from "./alertComponent";
import InlineDocumentation from './inlineDocumentation'

class StepManager extends React.Component {

    static defaultProps = {
        startStepId: 0,
        endStepId: 1,
        onFinished: () => null,
        stepList: [{
            stepId: 0,
            stepName: "",
            formValue: () => null,
            dataValue: null,
        }],
        progressBar: {
            active: true,
            spacer: ' -> ',
        },
        alert: {
            active: false,
        },

        documentation: null // {title:'', subtitle:'', brief:'', content:''}
    }

    constructor(props) {
        super(props);

        this.uniqueId = Math.floor(Math.random() * 10000000000);

        this.state = {
            progress: 0,

            alert: {
                show: false,
                message: 'message',
                variant: 'primary'
            }
        }

        this.setSteps = {}
    }

    openItem = (progress) => {
        let { controls } = this.getIdFromStep(progress);
        let elementShow = document.getElementById(controls);
        elementShow.classList.remove('hide');
        elementShow.classList.add('show');
    }

    collapseItem = (progress) => {
        let { controls } = this.getIdFromStep(progress);
        let elementCollapse = document.getElementById(controls);
        elementCollapse.classList.remove('show');
        elementCollapse.classList.add('hide');
    }


    goBack = (callback = () => { }) => {
        let { progress } = this.state;
        let prevProgress = progress - 1;
        if (progress > this.props.startStepId) {
            this.collapseItem(progress);
            this.openItem(prevProgress);
            this.setState({ progress: prevProgress }, callback);
        }
    }

    advance = (callback = () => { }) => {
        let { progress } = this.state;
        let nextProgress = progress + 1;
        if (progress < this.props.endStepId) {
            this.collapseItem(progress);
            this.openItem(nextProgress);
            this.setState({ progress: progress + 1 }, callback);
        }
        else if (progress === this.props.endStepId) {
            this.collapseItem(progress);
            this.setState({ progress: progress + 1 }, callback);
        }
    }

    isEnd = () => this.state.progress > this.props.endStepId;

    progressBar = () => {
        let { progress } = this.state;
        let { stepList, startStepId, endStepId, progressBar } = this.props;
        let spacer = progressBar.spacer || ' -> ';
        let label = '';
        let percent;

        if (!this.props.progressBar.active) { return null; }

        for (let i = startStepId; (i <= progress) && (i <= endStepId); i++) {
            label = label + spacer + stepList[i].stepName;
        }

        percent = progress === 0 ? '0' : this.isEnd() ? '100' : `${(100 / (this.props.endStepId + 1)) * progress}`;

        return (
            <div className="m-4">
                <ProgressBarComponent progressBarSet={{
                    label: label,
                    percent: percent
                }} />
            </div>
        );
    }

    showAlert = (message, variant) => {
        if (true === this.props.alert.active) {
            this.setState({ alert: { message: message, variant: variant, show: true } });
        }
        else {
            return null;
        }

    }

    renderAlert = () => {
        if (!this.props.alert.active) {
            return null;
        }

        let { alert } = this.state;
        return (
            <AlertComponent show={alert.show} variant={alert.variant} message={alert.message} dismissFunc={() => {
                this.setState({ alert: { show: false } });
            }} />
        );
    }


    getIdFromStep = (stepId) => {
        return {
            headId: 'heading' + this.uniqueId + stepId,
            dataTarget: "#collapse" + this.uniqueId + stepId,
            controls: "collapse" + this.uniqueId + stepId,
            showIfFirst: this.props.startStepId === stepId ? "show" : 'hide',
            isDisabled: this.state.progress < stepId,
            isDataValueEnabled: (!!this.props.stepList[stepId].dataValue)
        }
    }

    renderAccordionData = (stepId, isDataValueEnabled) => {
        let progress = this.state.progress;
        let contentMaker = this.props.stepList[stepId];

        if (progress < stepId) {
            return null;
        }
        else if ((progress === stepId) || (!isDataValueEnabled)) {
            return (
                <div>
                    <div className='text-right'>{this.stepDocumentation(contentMaker.stepName, contentMaker.documentation)}</div>
                    <div>{contentMaker.formValue()}</div>
                </div>);
        }
        else if ((progress > stepId) && (isDataValueEnabled)) {
            return (<div>
                <div>{this.stepDocumentation(contentMaker.stepName, contentMaker.documentation)}</div>
                <div>{contentMaker.dataValue()}</div>
            </div>);
        }
        return null;
    }

    renderAccordion = (stepId) => {
        let { headId, dataTarget, controls, showIfFirst, isDisabled, isDataValueEnabled } = this.getIdFromStep(stepId);
        return (
            <div key={stepId} id="accordion">
                <div className="card">
                    <div className="card-header" id={headId}>
                        <h5 className="mb-0">
                            <button className="btn btn-link" data-toggle="collapse" data-target={dataTarget}
                                aria-expanded="true" aria-controls={controls} disabled={isDisabled}>
                                {this.props.stepList[stepId].stepName}
                            </button>
                        </h5>
                    </div>
                    <div id={controls} className={["collapse", showIfFirst].join(' ')} aria-labelledby={headId}
                        data-parent="#accordion">
                        <div className="card-body text-left">
                            {this.renderAccordionData(stepId, isDataValueEnabled)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    // brief = (text) => { 
    //     if(!text.split) text = text.props.children;
    //     let brief = text.split('.')[0];
    //     let doc = brief.length === text.length? '' : text.substr(brief.length+1).trim();
    //     return {brief:brief, doc:doc};
    // }

    documentation = () => {
        let { documentation, stepList } = this.props;
        if (!documentation) {
            return null;
        }
        let contentList = stepList.map((step) => {
            if (!step.documentation) {
                return null;
            }
            return { title: step.stepName, content: step.documentation.brief };
        });

        return (
            <div className="justify-content-end">
                <button className="btn btn-outline-info p-3" type="button" data-toggle="collapse" data-target="#documentation-target" aria-expanded="true" aria-controls="collapseExample">
                    Documentation
                </button>
                <div className="collapse text-left" id="documentation-target">
                    <InlineDocumentation title={documentation.title} subtitle={documentation.subtitle} brief={documentation.brief}
                        content={
                            <p>{documentation.content}
                                <p>
                                    <p />
                                    <h4 className='text-success'>STEPS:</h4>
                                </p>
                            </p>}
                        contentList={contentList} />
                </div>
            </div>)
    }

    stepDocumentation = (title, documentation) => {
        if (!documentation) {
            return null;
        }
        let { brief, content } = documentation;

        return (
            <div className="justify-content-end">
                <button className="btn-sm btn-outline-info m-2 p-2" type="button" data-toggle="collapse" data-target="#step-documentation-target" aria-expanded="true" aria-controls="collapseExample">
                    Step Documentation
                </button>
                <div className="collapse text-left" id="step-documentation-target">
                    <InlineDocumentation subtitle={'Step ' + title} brief={brief} content={content} />
                </div>
            </div>)
    }

    render() {

        return (
            <div className="m-4 p-4">
                <div>
                    {this.documentation()}
                    {this.renderAlert()}
                    {this.progressBar()}
                    {
                        this.props.stepList.map(element => {
                            return (
                                <div>
                                    {this.renderAccordion(element.stepId)}
                                </div>);
                        })
                    }

                    <div className="p-4">
                        <button className="btn btn-success" hidden={!this.isEnd()}
                            onClick={this.props.onFinished}>  Finished  </button>
                    </div>
                </div>
            </div>
        )
    }
}


export default StepManager;